import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./ai-error.step.scss";

export const AiErrorStep = ({ error }) => (
  <div className="ai-error-step">
    <FontAwesomeIcon
      icon="fa-regular fa-triangle-exclamation"
      className="ai-error-step__icon"
    />
    <h2>Something went wrong</h2>
    <p>{error || "An unexpected error occurred. Please try again."}</p>
  </div>
);
